import { isProd, isTestMode } from '../../webpack/constants';

export const USE_REMOTE_DEV_BACKEND = false;

const TEST_HOST_NAME = 'https://langmagic-call-staging.up.railway.app';

const DEV_HOST_NAME = USE_REMOTE_DEV_BACKEND ? TEST_HOST_NAME : 'localhost:8085';

const PROD_HOST_NAME = 'meet.langmagic.com';

const BACK_HOST_DEV = `http://${DEV_HOST_NAME}`;
//const BACK_HOST_DEV = 'https://loc-app.langmagic.com'
const BACK_HOST_TEST = `https://${TEST_HOST_NAME}`;
const BACK_HOST_PROD = `https://${PROD_HOST_NAME}`;

export const VERSION = '1.95.0';

export const BASE_URL = isProd ? '/front/' : '/';

export enum EBuildMode {
  DEVELOPMENT = 0, TEST = 1, PRODUCTION
}

export const getBuildMode = (): EBuildMode => {
  if (isProd && isTestMode)
    return EBuildMode.TEST;
  if (isProd)
    return EBuildMode.PRODUCTION;
  return EBuildMode.DEVELOPMENT;
}

export const getBackHost = () => {
  // Set at build time (webpack DefinePlugin, see webpack/backend/plugins.js) so each deploy
  // target can point at its own backend without editing this file. isTestMode below is always 0
  // in this build pipeline, so EBuildMode.TEST/BACK_HOST_TEST are otherwise unreachable.
  if (process.env.BACKEND_HOST) {
    return process.env.BACKEND_HOST;
  }
  const buildMode = getBuildMode();
  switch (buildMode) {
    case EBuildMode.PRODUCTION:
      return BACK_HOST_PROD;
    case EBuildMode.TEST:
      return BACK_HOST_TEST;
    default:
      return BACK_HOST_DEV
  }
}

export const isTranslationApiEnabled = () => {
  return true; //isProd;
}

export const APP_TITLE = 'LangMagic';

export const API_URL = getBackHost() + '/api';
// served by the backend, not the SPA — on the dev server (:8080) a relative path renders an empty route
export const ADMIN_PANEL_URL = getBackHost() + '/admin/';

export const APP_KEY = 'AIzaSyDZH0eDJXqg74TpHXcqQ2IWokJGRk5X7CA';
export const FEEDBACK_URL = 'https://langmagic.com/feedback/';
export const TELEGRAM_BOT_URL = 'https://t.me/lang_project_feed_bot';
// LangMagic Coach bot (C:\projects\coach.langmagic); username comes from its TELEGRAM_BOT_USERNAME env.
// `?start=from_meet` tells the bot which app the learner came from (coach's router handles `from_<app>`)
export const COACH_BOT_URL = 'https://t.me/langmagic_coach_bot?start=from_meet';
export const LANGMAGIC_APPS = [
	{ title: 'Book', url: 'https://book.langmagic.com' },
	{ title: 'Speak', url: 'https://speak.langmagic.com' },
	{ title: 'Meet', url: 'https://meet.langmagic.com' },
	{ title: 'Video', url: 'https://portal.langmagic.com' },
];
export const YOUTUBE_URL = `https://youtube.com`;

export const CAPTION_START_POSITION = 3;

const GA4_ID_DEV = 'G-HZZZS25GM4';
const GA4_ID_PROD = 'G-S5ZXHWX05F'; // AW-11149840956 is the Ads tag, configured in index.html
// The shared LangMagic property (every app, split by hostname) — index.html configures it alongside.
export const GA4_ID_LANGMAGIC = 'G-LP6Q6EYH6M';

export const getGa4Id = () => {
  return isProduction() ? GA4_ID_PROD : GA4_ID_DEV;
}

export const isProduction = () => {
  return isProd
}

export const isEventsEnabled = () => {
  return isProductionHost();
}

export const isProductionHost = () => {
  return location.hostname.indexOf(PROD_HOST_NAME) === 0;
}

export const AMPLITUDE_API_KEY = '37bb462e444dfbe306fc5413482ac6f4';

export const SCROLLBAR_WIDTH = 6;

export const CLASS_DONT_CLOSE_TEXT_SELECTION = 'dont-close-text-selection';

// Transcription providers offered for a conference process
export const CONFERENCE_PROVIDERS = ['elevenlabs', 'assemblyai', 'deepgram', 'azure',] as const;
